export default {
  // spaces (areas) -----------------------------------------------------------
  async spacesCollection({dispatch}, [spaces, isExternalGuest, invites]) {
    dispatch('mixpanelTrack', ['Spaces Collection', {
      'Spaces': spaces,
      'Is External Guest': isExternalGuest,
      'Space Invites': invites
    }])
  },
  async createSpace({dispatch}, [name, step, data = {}]) {
    dispatch('mixpanelTrack', [name, {
      'Create Space Step': step,
      ...data
    }])
  },
  async enterSpace({dispatch, rootGetters}, type) {
    dispatch('mixpanelTrack', ['Enter Space', {
      'Enter Type': type,
      ...rootGetters.getCurrentAreaData
    }])
  },
  async enterJumpSpace({dispatch}, [id, type]) {
    dispatch('mixpanelTrack', ['Enter Jump Space', {
      'Portal Id': id,
      'Enter Type': type
    }])
  },
  // guest
  async enterSpaceLobbyAsGuest({dispatch}, [username, spaceId, data]) { //to wait to be accepted/go straight in if no lobby
    dispatch('mixpanelTrack', ['Enter Space Lobby As Guest', {
      'Username': username,
      'Space Id': spaceId,
      'API Response': data
    }])
  },
  async addOpenSpaceToCollectionAndRegister({dispatch}) {
    dispatch('mixpanelTrack', ['Register & Add Open Space To Collection'])
  },
  async enterSpaceAsExistingGuest({dispatch}, [userId, token, type]) { //to wait to be accepted/go straight in if no lobby
    dispatch('mixpanelTrack', ['Enter Space As Existing Guest', {
      'User Id': userId,
      'Token': token,
      'Type': type
    }])
  },
  // update/customise
  async customiseSpace({dispatch}, [data, roomUpdates]) {
    dispatch('mixpanelTrack', ['Customise Space', {
      'Room Updates': roomUpdates,
      ...data
    }])
  },
  async changeSpaceType({dispatch}, [type]) { //open/private space (when clicking on confirm on popup before save settings)
    dispatch('mixpanelTrack', ['Change Space Type Confirmed', {
      'Space Type': type
    }])
  },
  // leave
  async leaveSpace({dispatch}, type) { //switch space
    dispatch('mixpanelTrack', ['Leave Space', {
      'Leave Type': type
    }])
  },
  // remove
  async removeSpace({dispatch}, spaceId) { //remove space from collection
    dispatch('mixpanelTrack', ['Remove Space', {
      spaceName: '',
      spaceId: spaceId
    }])
  },

  // rooms --------------------------------------------------------------------
  async createRoomClick({dispatch}) {
    dispatch('mixpanelTrack', ['Create Room Button Click'])
  },
  async createRoomCancelled({dispatch}) {
    dispatch('mixpanelTrack', ['Create Room Cancelled'])
  },
  async createRoomCustomiseClick({dispatch}) {
    dispatch('mixpanelTrack', ['Create Room Customise Click'])
  },
  async createRoom({dispatch}, data) {
    dispatch('mixpanelTrack', ['Room Created', data])
  },
  async createPortalClick({dispatch}) {
    dispatch('mixpanelTrack', ['Create Portal Tab Click'])
  },
  async createPortalCancelled({dispatch}) {
    dispatch('mixpanelTrack', ['Create Portal Cancelled'])
  },
  async createPortalCustomiseClick({dispatch}) {
    dispatch('mixpanelTrack', ['Create Portal Customise Click'])
  },
  async createPortal({dispatch}, data) {
    dispatch('mixpanelTrack', ['Portal Created', data])
  },
  // view
  async viewRoom({dispatch}, data) {
    let isPortal = data?.location?.spaceType === 'portal'
    //has access?
    dispatch('mixpanelTrack', ['View Room', {...data, isPortal}])
  },
  async joinRoom({rootGetters, dispatch}) {
    let room = rootGetters.getCurrentUsersRoom
    dispatch('mixpanelTrack', ['Join Room', room])
  },
  // guest
  async enterRoomLobbyAsGuest({dispatch}, [username, roomId, data]) { //to wait to be accepted/go straight in if no lobby
    dispatch('mixpanelTrack', ['Enter Room Lobby As Guest', {
      'Username': username,
      'Room Id': roomId,
      'API Response': data
    }])
  },
  async enterRoomLobbyWithPassword({dispatch}, [roomId, data]) { //when guest waiting to be accepted
    dispatch('mixpanelTrack', ['Enter Room Lobby With Password', {
      'Room Id': roomId,
      'API Response': data
    }])
  },
  async joinRoomAsExistingGuest({dispatch}, [userId, token, type]) { //to wait to be accepted/go straight in if no lobby
    dispatch('mixpanelTrack', ['Join Room As Existing Guest', {
      'User Id': userId,
      'Token': token,
      'Type': type
    }])
  },
  async respondToGuestInRoomLobby({dispatch}, [roomId, userId, response]) { //accept/reject guest from room lobby
    dispatch('mixpanelTrack', ['Respond To Guest In Room Lobby', {
      'User Id': userId,
      'Room Id': roomId,
      'Response': response
    }])
  },
  async toggleRoomPassword({dispatch}, [roomId, state]) { //accept/reject guest from room lobby
    dispatch('mixpanelTrack', ['Toggle Room Guest Password', {
      'Room Id': roomId,
      'State': state
    }])
  },
  async toggleRoomLobby({dispatch}, [roomId, state]) { //accept/reject guest from room lobby
    dispatch('mixpanelTrack', ['Toggle Room Guest Lobby', {
      'Room Id': roomId,
      'State': state
    }])
  },
  async kickGuestFromRoom({dispatch}, data) { //kick guest from room
    dispatch('mixpanelTrack', ['Kick Guest From Room', data])
  },
  async promoteGuestToRoomCoHost({dispatch}, data) { //kick guest from room
    dispatch('mixpanelTrack', ['Promote Guest To Room Co-Host', data])
  },
  // leave
  async leaveRoom({rootGetters, dispatch}, type) {
    dispatch('mixpanelTrack', ['Leave Room', {
      ...rootGetters.getCurrentUsersRoom,
      'Enter Type': type
    }])
  },
  // edit/customise
  async editRoom({dispatch}, data) {
    dispatch('mixpanelTrack', ['Edit Room', {
      'Room Id': data.id,
      ...data
    }])
  },
  // delete
  async deleteRoom({dispatch}, data) {
    let isPortal = data?.location?.spaceType === 'portal'
    dispatch('mixpanelTrack', ['Delete Room', {...data, isPortal}])
  },


  // shutdown --------------------------------------------------------------------
  async forcedShutdown({dispatch}) {
    dispatch('mixpanelTrack', ['Forced Shutdown'])
  },
}
